export default __webpack_public_path__ + "static/media/albert_chen.2f18a378.png";